import React from "react";
import { useTranslation } from "react-i18next";
import { EditOutlined, DeleteOutlined, FileTextOutlined } from "us.icons";
import { $Popconfirm } from "us.common/components";
import { ClosureCodesActions } from "us.collection.admin/constants";
import { IItemMenu } from "us.collection.admin/components/ClosureCodes/Components/Table";

/**
 * @description - Manage Closure Code Edit/Log/Delete popover view
 * @author Tharanga Niroshana <tharangan@unicorn-solutions.com>
 * @since 11/07/2024
 */

const ItemMenu: React.FC<IItemMenu> = ({
  actions = [
    ClosureCodesActions.EDIT,
    ClosureCodesActions.LOG,
    ClosureCodesActions.DELETE,
  ],
  onCallAction,
}) => {
  
  const { t } = useTranslation();

  return (
    <div className="table-more-content">
      {actions.includes(ClosureCodesActions.EDIT) && (
        <div
          className="d-flex  flex-row more-item"
          onClick={() => onCallAction(ClosureCodesActions.EDIT)}
        >
          <div className="p-1">
            <EditOutlined  />
          </div>
          <div className="p-1">{t("US.COLLECTION.COMMON:COMMON.EDIT")}</div>
        </div>
      )}
      {actions.includes(ClosureCodesActions.LOG) && (
        <div
          className="d-flex  flex-row more-item"
          onClick={() => onCallAction(ClosureCodesActions.LOG)}
        >
          <div className="p-1">
            <FileTextOutlined />
          </div>
          <div className="p-1">
            {t("US.COLLECTION.ADMIN:MANAGE_CLOSURE_CODES.LOG")}
          </div>
        </div>
      )}
      {actions.includes(ClosureCodesActions.DELETE) && (
        <div>
          <$Popconfirm
            title={t("US.COLLECTION.COMMON:COMMON.SURE_TO_DELETE_?")}
            onConfirm={() => onCallAction(ClosureCodesActions.DELETE)}
          >
            <div className="d-flex mb-2 flex-row more-item text-error">
              <div className="p-1">
                <DeleteOutlined />
              </div>
              <div className="p-1">
                {t("US.COLLECTION.COMMON:COMMON.DELETE")}
              </div>
            </div>
          </$Popconfirm>
        </div>
      )}
    </div>
  );
};

export default ItemMenu;
